import { Environment } from '../app/enums';

interface EnvironmentConfig {
    API_URL: string;
    ADMIN_API_URL: string;
    /** Where an agency goes straight after installing, to start its free trial. */
    INSTALL_TRIAL_URL: string;
}

const env: EnvironmentConfig = {
    API_URL: import.meta.env.VITE_API_URL || "http://localhost:8084",
    /** Platform API (embed session, branding, agency locale). Override for local xylator backend. */
    ADMIN_API_URL:
        import.meta.env.VITE_ADMIN_API_URL?.trim() || "https://api.xylatorai.com",
    /*
     * The install flow ends on the NexGenHighlevel trial page rather than on a
     * "done" screen. Overridable so a staging build cannot drop testers onto
     * live signup.
     */
    INSTALL_TRIAL_URL:
        import.meta.env.VITE_INSTALL_TRIAL_URL?.trim() ||
        "https://install.nexgenhighlevel.com/whatsapp-ct",
};

// }
export default env;
